import { SET_UPLOAD_STATE } from './actiontypes';
import { createEmptyBuilding } from '../../api/Api';
import { setUploadState } from './ui';
import { UPLOAD_STATES } from '../reducers/ui';
import fetchBuildingsActionCreator, { invalidateBuildingsAction } from './buildings';

export function setUploadStateNewAction() {
  return {
    type: SET_UPLOAD_STATE,
    uploadState: UPLOAD_STATES.NEW,
  };
}

export const createEmptyBuildingActionCreator = (buildingName, orgId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  dispatch(setUploadState(UPLOAD_STATES.PROCESSING));
  return createEmptyBuilding(jwt, buildingName, orgId).then(
    (data) => {
      // refresh building list (get metadata from server)
      dispatch(invalidateBuildingsAction());
      dispatch(fetchBuildingsActionCreator());
      dispatch(setUploadState(UPLOAD_STATES.SUCCESS));
      return Promise.resolve(data);
    },
    (error) => {
      if (error && !error.message.includes('User session expired')) {
        dispatch(setUploadState(UPLOAD_STATES.FAIL));
      }
      return Promise.reject(error);
    }
  );
};
